(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bgm-zuletzt"] && !Shopify.designMode) return;
  try {
    
(function () {
  var kasten = document.querySelector('.bgm-zuletzt');
  if (!kasten) return;
  var SCHLUESSEL = 'bgm-zuletzt-gesehen';
  var aktuell = kasten.dataset.aktuell;
  var anzahl = parseInt(kasten.dataset.anzahl, 10) || 5;

  function lies() {
    try { return JSON.parse(localStorage.getItem(SCHLUESSEL)) || []; }
    catch (e) { return []; }
  }
  var liste = lies().filter(function (h) { return h && h !== aktuell; });

  if (aktuell) {
    var neu = [aktuell].concat(liste).slice(0, 20);
    try { localStorage.setItem(SCHLUESSEL, JSON.stringify(neu)); } catch (e) {}
  }

  var reihe = kasten.querySelector('.bgm-zuletzt__reihe');
  var zuZeigen = liste.slice(0, anzahl);
  if (!zuZeigen.length) return;

  Promise.all(zuZeigen.map(function (h) {
    return fetch('/products/' + h + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  })).then(function (artikel) {
    var gebaut = 0;
    artikel.forEach(function (p) {
      if (!p) return;
      var a = document.createElement('a');
      a.className = 'bgm-zuletzt__karte';
      a.href = '/products/' + p.handle;
      var bild = p.featured_image
        ? '<img class="bgm-zuletzt__bild" src="' + p.featured_image +
          '&width=400" alt="" loading="lazy">' : '';
      var preis = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
      a.innerHTML = bild +
        '<span class="bgm-zuletzt__name"></span>' +
        '<span class="bgm-zuletzt__preis">' + preis + '</span>';
      a.querySelector('.bgm-zuletzt__name').textContent = p.title;
      reihe.appendChild(a);
      gebaut++;
    });
    if (gebaut) kasten.classList.add('bgm-zuletzt--gefuellt');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
